import { useLocation } from 'react-router-dom';

import { decodeQueryParams } from 'shared/lib/queryParams/decodeQueryParams';

export function useQueryParams<T = Record<string, unknown>>() {
  return decodeQueryParams<T>(useLocation().search);
}
